import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import Link from "next/link";
import Head from "next/head";
import { API_BASE_URL } from "../../../libs/generalSettings";
import { get } from "../../../libs/services/request";
import Logo from "../../../public/static/imgs/template/footer-logo.png";

import {
  MetinKisalt,
  SeoUrlRegex,
  isInjectionValid,
} from "../../../libs/utils";
import Language from "../../../locales/GetLanguageResourceResponse.json";
import Loader from "../../../components/Loader";
import { SortByName } from "../../../libs/enums";
import Image from "next/image";
import star from "../../../public/static/imgs/template/icons/star.svg";
import { motion } from "framer-motion";

const SearchDetail = () => {
  const router = useRouter();
  const { slug, id } = router.query;
  let itemsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [loaderIsShow, setLoaderIsShow] = useState(false);
  const [pageTitle, setPageTitle] = useState("");

  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(10000);
  const [UrunlerByKategori, setUrunlerByKategori] = useState([]);
  const [GetKategoriler, setGetKategoriler] = useState([]);
  const [allFilterSelectName, setAllFilterSelectName] = useState("");
  const [language, setLanguage] = useState("tr");
  const languageStore = useSelector((state) => state.language);
  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  useEffect(() => {
    (async () => {
      await get(
        `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?${
          id === "0" ? "" : `kategoriId=${id}`
        }&urunAdi=${slug}&pageNumber=0&pageSize=10000&sortingDESCorASC=DESC&dil=${languageStore}`
      ).then((result) => {
        {
          if (result.sonuc === true) {
            setLanguage(languageStore);
            setUrunlerByKategori(result.data);
            setPageTitle(
              result.data.length > 0
                ? result.data[0].kategoriEnt.urunaciklama
                : ""
            );
            setLoaderIsShow(true);
          } else {
          }
        }
      });
    })();
  }, [slug, languageStore]);
  useEffect(() => {
    (async () => {
      await get(`${API_BASE_URL}/getKategoriler?dil=${languageStore}`).then(
        (result) => {
          {
            if (result.sonuc === true) {
              setGetKategoriler(result.data);
              setAllFilterSelectName(
                Language[languageStore].kategoriDetaySayfaTumUrunlerTitle
              );
            } else {
              router.push("/notfound");
            }
          }
        }
      );
    })();
  }, [languageStore]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = UrunlerByKategori.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const goToNextPage = () => {
    if (currentPage < Math.ceil(UrunlerByKategori.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleMinInputChange = (event) => {
    setMinValue(event.target.value);
  };
  const handleMaxInputChange = (event) => {
    setMaxValue(event.target.value);
  };

  const handleAllFilter = (event) => {
    const targetId = event.target.id;
    if (targetId === SortByName.TumUrunler) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategori?urunKod=${id}&dil=${languageStore}`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);

              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    } else if (targetId === SortByName.AZGoreSirala) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?kategoriId=${id}&ucretStart=${minValue}&ucretFinish=${maxValue}&pageNumber=0&pageSize=10000&sortingDESCorASC=ASC&dil=${languageStore}`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);
              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    } else if (targetId === SortByName.EnYeniUrunler) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?kategoriId=${id}&ucretStart=${minValue}&ucretFinish=${maxValue}&pageNumber=0&pageSize=10000&sortingDESCorASC=DESC&dil=${languageStore}&sortingParameterName=cikis_tarih`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);
              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    } else if (targetId === SortByName.Filtrele) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?kategoriId=${id}&ucretStart=${minValue}&ucretFinish=${maxValue}&pageNumber=0&pageSize=10000&sortingDESCorASC=DESC&dil=${languageStore}&sortingParameterName=ucret`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);
              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    } else if (targetId === SortByName.UcuzdanPahaliya) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?kategoriId=${id}&ucretStart=${minValue}&ucretFinish=${maxValue}&pageNumber=0&pageSize=10000&sortingDESCorASC=ASC&dil=${languageStore}&sortingParameterName=ucret`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);
              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    } else if (targetId === SortByName.PahalidanUcuza) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?kategoriId=${id}&ucretStart=${minValue}&ucretFinish=${maxValue}&pageNumber=0&pageSize=10000&sortingDESCorASC=DESC&dil=${languageStore}&sortingParameterName=ucret`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);
              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    } else if (targetId === SortByName.EskiUrunler) {
      (async () => {
        await get(
          `${API_BASE_URL}/getUrunlerByKategoriIdOrUrunAdi?kategoriId=${id}&ucretStart=${minValue}&ucretFinish=${maxValue}&pageNumber=0&pageSize=10000&sortingDESCorASC=ASC&dil=${languageStore}&sortingParameterName=cikis_tarih`
        ).then((result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setUrunlerByKategori(result.data);
              setLoaderIsShow(true);
            } else {
            }
          }
        });
      })();
    }
  };

  return (
    <>
      <Head>
        <title>
          {Language[languageStore].webTitle} | {pageTitle}
        </title>
      </Head>
      {!loaderIsShow ? <Loader /> : ""}

      <div className="section-box shop-template mt-30">
        <div className="container">
          <div className="row">
            {" "}
            {currentItems.length > 0 ? (
              <>
                <div className="col-lg-9 order-first order-lg-last">
                  <div className="box-filters mt-0 pb-5 border-bottom">
                    <div className="row">
                      <div className="col-xl-4 col-lg-3 mt-3 text-lg-start text-center">
                        <h6 className="">
                          {pageTitle} - [{slug}]
                        </h6>
                      </div>

                      <div className="col-xl-8 col-lg-9 mb-10 text-lg-end text-center">
                        <div className="d-inline-block">
                          <span className="font-sm color-gray-500 font-medium">
                            {
                              Language[languageStore]
                                .kategoriDetaySayfaSıralaTitle
                            }
                            :
                          </span>
                          <div className="dropdown dropdown-sort border-1-right">
                            <button
                              className="btn dropdown-toggle font-sm color-gray-900 font-medium"
                              id="dropdownSort"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {allFilterSelectName}
                            </button>
                            <ul
                              className="dropdown-menu dropdown-menu-light"
                              aria-labelledby="dropdownSort"
                              style={{ margin: "0px" }}>
                              <li>
                                <a
                                  id={SortByName.TumUrunler}
                                  onClick={(e) => {
                                    setAllFilterSelectName(
                                      Language[languageStore]
                                        .kategoriDetaySayfaTumUrunlerTitle
                                    ),
                                      handleAllFilter(e);
                                  }}
                                  className="dropdown-item"
                                  href="#">
                                  {
                                    Language[languageStore]
                                      .kategoriDetaySayfaTumUrunlerTitle
                                  }
                                </a>
                              </li>
                              <li>
                                <a
                                  id={SortByName.AZGoreSirala}
                                  onClick={(e) => {
                                    setAllFilterSelectName(
                                      Language[languageStore]
                                        .kategoriDetaySayfaAZGoreTitle
                                    ),
                                      handleAllFilter(e);
                                  }}
                                  className="dropdown-item"
                                  href="#">
                                  {
                                    Language[languageStore]
                                      .kategoriDetaySayfaAZGoreTitle
                                  }
                                </a>
                              </li>
                              <li>
                                <a
                                  id={SortByName.UcuzdanPahaliya}
                                  onClick={(e) => {
                                    setAllFilterSelectName(
                                      Language[languageStore]
                                        .kategoriDetaySayfaUcuzdanPahaliyaTitle
                                    ),
                                      handleAllFilter(e);
                                  }}
                                  className="dropdown-item"
                                  href="#">
                                  {
                                    Language[languageStore]
                                      .kategoriDetaySayfaUcuzdanPahaliyaTitle
                                  }
                                </a>
                              </li>
                              <li>
                                <a
                                  id={SortByName.PahalidanUcuza}
                                  onClick={(e) => {
                                    setAllFilterSelectName(
                                      Language[languageStore]
                                        .kategoriDetaySayfaPahalidanUcuzaTitle
                                    ),
                                      handleAllFilter(e);
                                  }}
                                  className="dropdown-item"
                                  href="#">
                                  {
                                    Language[languageStore]
                                      .kategoriDetaySayfaPahalidanUcuzaTitle
                                  }
                                </a>
                              </li>
                              <li>
                                <a
                                  id={SortByName.EnYeniUrunler}
                                  onClick={(e) => {
                                    setAllFilterSelectName(
                                      Language[languageStore]
                                        .kategoriDetaySayfaEnYeniUrunGoreTitle
                                    ),
                                      handleAllFilter(e);
                                  }}
                                  className="dropdown-item"
                                  href="#">
                                  {
                                    Language[languageStore]
                                      .kategoriDetaySayfaEnYeniUrunGoreTitle
                                  }
                                </a>
                              </li>
                              <li>
                                <a
                                  id={SortByName.EskiUrunler}
                                  onClick={(e) => {
                                    setAllFilterSelectName(
                                      Language[languageStore]
                                        .kategoriDetaySayfaEnEskiUrunGoreTitle
                                    ),
                                      handleAllFilter(e);
                                  }}
                                  className="dropdown-item"
                                  href="#">
                                  {
                                    Language[languageStore]
                                      .kategoriDetaySayfaEnEskiUrunGoreTitle
                                  }
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <motion.div
                    variants={container}
                    initial="hidden"
                    animate="visible"
                    className="row mt-5">
                    {currentItems &&
                      currentItems?.map((products, index) => (
                        <motion.div
                          key={index}
                          variants={item}
                          className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                          <div className="card-grid-style-3">
                            <div className="card-grid-inner">
                              <div className="image-box">
                                <Link
                                  href={`/urunler/${SeoUrlRegex(
                                    products.urunAd
                                  )}/${products.urunId}`}
                                  title={products.urunAd}>
                                  {" "}
                                  <img
                                    src={products.resimLink}
                                    width={500}
                                    height={300}
                                    alt={products.urunAd}
                                    title={products.urunAd}
                                  />
                                </Link>
                              </div>
                              <div className="info-right">
                                <Link
                                  className="font-xs color-gray-500"
                                  href={`/urunler/${SeoUrlRegex(
                                    products.urunAd
                                  )}/${products.urunId}`}
                                  title={products.urunAd}>
                                  {products.kategoriAdi == undefined
                                    ? products.kategoriEnt.urunaciklama
                                    : products.kategoriAdi}
                                </Link>
                                <br />
                                <Link
                                  className="color-brand-3 font-sm-bold"
                                  href={`/urunler/${SeoUrlRegex(
                                    products.urunAd
                                  )}/${products.urunId}`}
                                  title={products.urunAd}>
                                  {" "}
                                  <MetinKisalt
                                    text={
                                      products.urunAd === null
                                        ? "null"
                                        : products.urunAd
                                    }
                                    maxLength={20}
                                  />
                                </Link>

                                <div className="rating">
                                  <div className="ptt-rating">
                                    <Image src={star} alt={products.urunAd} />
                                    <Image src={star} alt={products.urunAd} />
                                    <Image src={star} alt={products.urunAd} />
                                    <Image src={star} alt={products.urunAd} />
                                    <Image src={star} alt={products.urunAd} />
                                    <br />
                                    <span className="font-xs color-gray-500">
                                      {Language[languageStore].stokAdetiTitle}:
                                      ({products.stokAdet})
                                    </span>
                                  </div>
                                </div>
                                <div className="price-info">
                                  <strong className="font-lg-bold color-brand-3 price-main">
                                    {products.ucret}&nbsp;TL
                                  </strong>
                                </div>
                                <div className="mt-20 box-btn-cart">
                                  <Link
                                    className="btn btn-cart"
                                    href={`/urunler/${SeoUrlRegex(
                                      products.urunAd
                                    )}/${products.urunId}`}
                                    title={products.urunAd}>
                                    {Language[languageStore].urunDetayBtnTitle}
                                  </Link>
                                </div>
                                <ul className="list-features">
                                  <li>
                                    {Language[languageStore].urunKoduTitle} :{" "}
                                    {products.urunKod}
                                  </li>
                                  <li>
                                    {Language[languageStore].baskiYontemiTitle}{" "}
                                    :{products.baskiYontemi}
                                  </li>
                                  <li>
                                    {Language[languageStore].basimEviTitle} :
                                    {products.basimevi}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      ))}
                  </motion.div>
                  <nav className="ptt-pagination-nav">
                    <ul className="pagination">
                      <li key={2} className="page-item">
                        <a
                          onClick={goToPreviousPage}
                          className="page-link page-prev"
                          href="#">
                          {Language[languageStore].oncekiSayfa}
                        </a>
                      </li>
                      {Array.from(
                        {
                          length: Math.ceil(
                            UrunlerByKategori.length / itemsPerPage
                          ),
                        },
                        (_, index) => (
                          <li key={index} className="page-item">
                            <a
                              key={index}
                              onClick={() => paginate(index + 1)}
                              className={
                                currentPage === index + 1
                                  ? "page-link active"
                                  : "page-link"
                              }
                              href="#">
                              {index + 1}
                            </a>
                          </li>
                        )
                      )}
                      <li key={1} className="page-item">
                        <a
                          onClick={goToNextPage}
                          className="page-link page-next"
                          href="#">
                          {Language[languageStore].sonrakiSayfa}
                        </a>
                      </li>
                    </ul>
                  </nav>{" "}
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-9 order-first order-lg-last">
                  <div className="row">
                    <motion.div
                      variants={container}
                      initial="hidden"
                      animate="visible"
                      className="row">
                      <div className="ptt-not-found">
                        <div className="text-center mb-150 mt-50">
                          <div className="mb-20">
                            {" "}
                            <Image
                              className=""
                              style={{ objectFit: "contain" }}
                              height={80}
                              src={Logo}
                              alt="Ptt Filateli"
                            />
                          </div>

                          <h3 className="font-lg mb-5 ptt-not-found-color">
                            {Language[languageStore].urunYokTitle}
                          </h3>
                          <p className="font-md ptt-not-found-color">
                            {Language[languageStore].urunYokSlogan}
                          </p>
                          <div className="mt-15">
                            {" "}
                            <Link
                              href="/"
                              className="btn btn-pttFilateli w-auto">
                              {" "}
                              {Language[languageStore].notFoundBtnTitle}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>
              </>
            )}
            <div className="col-lg-3 order-last order-lg-first">
              <div className="sidebar-border mb-0">
                <div className="sidebar-head">
                  <h6 className="color-gray-900">
                    {Language[languageStore].kategorilerTitle}
                  </h6>
                </div>
                <div className="sidebar-content">
                  <ul className="list-nav-arrow">
                    {GetKategoriler &&
                      GetKategoriler?.map((category, index) => {
                        return (
                          <li key={index}>
                            <Link
                              className={
                                category.urunaciklama === pageTitle
                                  ? "ptt-category-link-active"
                                  : ""
                              }
                              href={`/kategoriler/${SeoUrlRegex(
                                category.urunaciklama
                              )}/${category.urunkod}`}
                              title={category.urunaciklama}>
                              {category.urunaciklama}
                            </Link>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
              <div className="sidebar-border mb-40 mt-10">
                <div className="sidebar-head">
                  <h6 className="color-gray-900">
                    {" "}
                    {
                      Language[languageStore]
                        .kategoriDetaySayfaUrunFiltreleTitle
                    }
                  </h6>
                </div>
                <div className="sidebar-content">
                  <div className="box-slider-range mt-0 mb-0">
                    <div className="row mb-10">
                      <div className="ptt-filter-container">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label
                              className="color-gray-900 mt-10 mb-10"
                              htmlFor="min-price">
                              {
                                Language[languageStore]
                                  .kategoriDetaySayfaMinFiyatTitle
                              }
                              :
                            </label>
                            <input
                              type="text"
                              id="min-price"
                              value={minValue}
                              className="form-control"
                              onChange={handleMinInputChange}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label
                              className="color-gray-900 mt-10 mb-10"
                              htmlFor="max-price">
                              {
                                Language[languageStore]
                                  .kategoriDetaySayfaMaxFiyatTitle
                              }
                              :
                            </label>
                            <input
                              type="text"
                              id="max-price"
                              value={maxValue}
                              className="form-control"
                              onChange={handleMaxInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <a
                        className="btn btn-pttFilateli"
                        id={SortByName.Filtrele}
                        onClick={(e) => {
                          handleAllFilter(e);
                        }}>
                        {
                          Language[languageStore]
                            .kategoriDetaySayfaFiltreleBtnTitle
                        }
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SearchDetail;
